import React from 'react';
import { BonusSection } from './components/BonusSection';
import { ChecklistSection } from './components/ChecklistSection';
import { CostSection } from './components/CostSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { MoreResults } from './components/MoreResults';
import { PremiumSection } from './components/PremiumSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SocialProof } from './components/SocialProof';
import { SummaryTable } from './components/SummaryTable';
import { Testimonials } from './components/Testimonials';
import { UrgencySection } from './components/UrgencySection';
export function App() {
  return <div className="min-h-screen w-full overflow-hidden bg-mist text-ink" data-id="element-0" data-mp="3mk85gw6ag7ch">
      <MetaPixel data-id="element-1" data-mp="3rbzmaezn6ypf" />
      <main data-id="element-2" data-mp="3rdkisa5iorpx">
        <Hero data-id="element-3" data-mp="3rcsxbs5mwadd" />
        <SocialProof data-id="element-4" data-mp="3recd7hndojem" />
        <Testimonials data-id="element-5" data-mp="5yh2n2cyzbp" />
        <ProblemSection data-id="element-6" data-mp="67yvnd9206b" />
        <ModulesSection data-id="element-7" data-mp="5gez9t0lqvv" />
        <ChecklistSection data-id="element-8" data-mp="82j0zgp5o9c" />
        <BonusSection data-id="element-9" data-mp="2zld259q0hfbj" />
        <UrgencySection data-id="element-10" data-mp="2zm4yimrfnh2v" />
        <PricingSection data-id="element-11" data-mp="2zmo7vf30ox5a" />
        <PremiumSection data-id="element-12" data-mp="2zng2onosiqui" />
        <MoreResults data-id="element-13" data-mp="33m5am0r27g6r" />
        <GuaranteeSection data-id="element-14" data-mp="33nq5jrhad155" />
        <FAQ data-id="element-15" data-mp="33mykvbp88ntn" />
        <CostSection data-id="element-16" data-mp="33oi3h8ycvayl" />
        <SummaryTable data-id="element-17" data-mp="38m1e7yvuh5ls" />
        <FinalCta data-id="element-18" data-mp="38kqcs5pvg9xu" />
      </main>
      <Footer data-id="element-19" data-mp="38kgk2adfzoog" />
      <PurchaseNotification data-id="element-20" data-mp="38o4gbha9up6v" />
    </div>;
}